import api from "../../client";

export type PathReasonsResponseData = string[];

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const getPathReasonsRequest =
  async (): Promise<PathReasonsResponseData> => {
    const { data } = await api.get<ApiResponse<PathReasonsResponseData>>(
      "/profile/enums/path-reasons",
    );
    return data.data;
  };
